import { render, staticRenderFns } from "./ChangeModulStatusDialog.vue?vue&type=template&id=083b0546"
import script from "./ChangeModulStatusDialog.vue?vue&type=script&lang=js"
export * from "./ChangeModulStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports